import { gql } from '@lcs/shared/api';

export const getActiveCallSegmentsAndRecordings = gql`
   query GetActiveCallSegmentsAndRecordings($id: UInt!) {
      activeCall(id: $id) {
         callDetailId
         callDirectionTypeId
         serverName
         sipCallId
         providerId
         sourceProviderId
         destinationProviderId
         sourceIpAddress
         destinationIpAddress
         stirShakenVerification
         stirShakenAttest
         stirShakenToken
         callSegmentsConnection {
            items {
               callSegmentId
               callDetailId
               sourceExtensionId
               extensionId
               sourceExtension {
                  extensionId
                  extensionType {
                     name
                  }
                  name
                  number
               }
               extension {
                  extensionId
                  extensionType {
                     name
                  }
                  name
                  number
               }
               startDate
               endDate
               endDate
               duration
               sequence
            }
         }
         queueHistoryCallDetailsConnection {
            items {
               queueHistory {
                  queueHistoryId
                  callDetailId
                  queueExtensionId
                  enqueuedDateTime
                  callbackCompleteDateTime
                  callbackRequestDateTime
                  callDispositionId
                  queueAgentDialsConnection {
                     items {
                        queueAgentDialId
                        queueHistoryId
                        agentExtension {
                           extensionId
                           name
                           number
                        }
                        dialStartTime
                        dialEndTime
                        dialStatus
                     }
                  }
                  queueCallbackDialsConnection {
                     items {
                        queueCallbackDialId
                        dialStartTime
                        dialEndTime
                     }
                  }
                  queueHistoryCallDetailsConnection {
                     items {
                        callDetailId
                     }
                  }
               }
            }
         }
         callRecording {
            file {
               fileId
               fileToken
               fileName
               displayName
            }
         }
      }
   }
`;

export const getActiveCallSegmentsAndRecordingsForQueueCallDetails = gql`
   query GetActiveCallSegmentsAndRecordingsForQueueCallDetails($id: UInt!) {
      activeCall(id: $id) {
         callDetailId
         account {
            accountId
            name
         }
         callerChannelId
         serverName
         sipCallId
         providerId
         sourceProviderId
         destinationProviderId
         sourceIpAddress
         destinationIpAddress
         stirShakenVerification
         stirShakenAttest
         stirShakenToken
         startTime
         callDirectionTypeId
         providerId
         destinationIpAddress
         originalDestinationNumber
         sourceExtension {
            extensionId
            number
            name
         }
         sourceNumber
         destinationExtension {
            extensionId
            number
            name
         }
         destinationNumber
         sourceExtensionId
         sourceNumber
         callSegmentsConnection {
            items {
               callSegmentId
               callDetailId
               sourceExtensionId
               extensionId
               sourceExtension {
                  extensionId
                  extensionType {
                     name
                  }
                  name
                  number
               }
               extension {
                  extensionId
                  extensionType {
                     name
                  }
                  name
                  number
               }
               startDate
               endDate
               duration
               sequence
            }
         }
         queueHistoryCallDetailsConnection {
            items {
               queueHistory {
                  queueHistoryId
                  callDetailId
                  queueExtensionId
                  enqueuedDateTime
                  callbackCompleteDateTime
                  callbackRequestDateTime
                  callDispositionId
                  queueAgentDialsConnection {
                     items {
                        queueAgentDialId
                        queueHistoryId
                        agentExtension {
                           extensionId
                           name
                           number
                        }
                        dialStartTime
                        dialEndTime
                        dialStatus
                     }
                  }
                  queueCallbackDialsConnection {
                     items {
                        queueCallbackDialId
                        dialStartTime
                        dialEndTime
                     }
                  }
                  queueHistoryCallDetailsConnection {
                     items {
                        callDetailId
                     }
                  }
               }
            }
         }
         callRecording {
            file {
               fileId
               fileToken
               fileName
               displayName
            }
         }
      }
   }
`;
